import {
	Directive,
	ElementRef,
	EventEmitter,
	OnDestroy,
	Output
}                    from '@angular/core';
import {
	IScrollData,
	IScrollDataBase
}                    from '@app/core/interfaces/common.interfaces';
import { fromEvent } from 'rxjs';


@Directive( {
	selector: '[appScrollEvent]'
} )
export class ScrollEventDirective implements OnDestroy {

	private scrollEvent$;

	@Output() scrollPosition: EventEmitter<number> = new EventEmitter<number>();

	@Output() scrollData: EventEmitter<IScrollData> = new EventEmitter<IScrollData>();

	constructor( private el: ElementRef ) {
		this.scrollEvent$ = fromEvent( this.el.nativeElement, 'scroll' )
		.subscribe( ( e: any ) => {
			const targetElement = e.target;
			this.scrollPosition.emit( targetElement.scrollTop );
			this.scrollData.emit( this.getScrollData( targetElement ) );
		} );
	}

	private getBaseScrollData( el: any ): IScrollDataBase {
		return {
			target: el,
			clientTop: el.clientTop,
			clientLeft: el.clientLeft,
			clientWidth: el.clientWidth,
			clientHeight: el.clientHeight,

			offsetTop: el.offsetTop,
			offsetLeft: el.offsetLeft,
			offsetWidth: el.offsetWidth,
			offsetHeight: el.offsetHeight,

			scrollTop: el.scrollTop,
			scrollLeft: el.scrollLeft,
			scrollWidth: el.scrollWidth,
			scrollHeight: el.scrollHeight
		};
	}

	private getScrollData( el: any ): IScrollData {

		let elementsScrollData: IScrollData;
		elementsScrollData = this.getBaseScrollData( el );

		const offsetParentElement = el.offsetParent;
		if ( offsetParentElement ) {
			const offsetParent = this.getBaseScrollData( offsetParentElement );
			elementsScrollData = {
				...elementsScrollData,
				targetFitMaxHeight: offsetParent.clientHeight - elementsScrollData.offsetTop,
				offsetParent
			};
		}

		return elementsScrollData;
	}

	ngOnDestroy(): void {
		this.scrollEvent$.unsubscribe();
	}

	updateScrollData( el: any ): IScrollData {
		if ( !el ) { return; }
		return this.getScrollData( el );
	}
}
